import type { GlossaryDictionaryListItem } from '@ai-meeting/shared'
import { DocumentIcon, DownloadIcon, LockIcon } from '@/components/Icons'
import { useUiStrings } from '@/hooks/useUiStrings'

interface SystemDictionaryRowProps {
  dictionary: GlossaryDictionaryListItem
  onDownload: () => void
}

function formatTermCount(count: number, locale: string): string {
  return count.toLocaleString(locale === 'ja' ? 'ja-JP' : 'en-US')
}

export default function SystemDictionaryRow({
  dictionary,
  onDownload,
}: SystemDictionaryRowProps) {
  const { t, locale } = useUiStrings()

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-[var(--border-color)] bg-[var(--bg-secondary)] px-4 py-3.5">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-[var(--accent-light)] text-[var(--accent)]">
        <DocumentIcon className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-[var(--text-primary)]">
          {dictionary.name}
        </p>
        <p className="mt-0.5 text-xs text-[var(--text-tertiary)]">
          {formatTermCount(dictionary.termCount, locale)} {t.glossaryTermsLabel} ·{' '}
          {t.glossarySystemLabel}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <LockIcon className="h-4 w-4 text-[var(--text-tertiary)]" aria-hidden />
        <button
          type="button"
          onClick={onDownload}
          className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-[var(--border-color)] bg-[var(--bg-secondary)] px-3 text-xs font-semibold text-[var(--text-primary)] transition-colors hover:bg-[var(--bg-tertiary)]"
        >
          <DownloadIcon className="h-3.5 w-3.5" />
          {t.glossaryDownload}
        </button>
      </div>
    </div>
  )
}
